module.exports = __webpack_public_path__ + "static/media/slider-l1-768.a1634d2c.webp";